<template>
  <div class="detail">
    <van-nav-bar
      title="详情"
    />
    <van-tabs v-model="actives" animated>
    <van-tab title="订单详情">
      <div class="headerTitle">订单信息</div>
        <div class="orderBox">
          <p class="orderTitle">{{DetailsInfo.title}}</p>
          <p class="orderPrice">{{DetailsInfo.siteName}}</p>
          <p class="orderStatus">预计金额：{{DetailsInfo.orderFee / 100 | PriceFilter}} 元</p>
          <p class="orderPrice">核准金额：{{DetailsInfo.approvalFee / 100 | PriceFilter}} 元</p>
          <p class="orderStatus">{{DetailsInfo.orderStatus | orderStatusFilter(DetailsInfo.orderType) }}</p>
          <div class="orderDetalis">
            <p class="orderId">订单编号：{{DetailsInfo.orderId}}</p>
            <p class="orderTime">下单时间：{{DetailsInfo.createTime | DateFilter('yyyy-MM-dd hh:mm:ss')}}</p>
          </div>
          <div class='headerTitle'>订单详情</div>
            <van-divider />
            <div class='imgbox'>
              <!-- <image mode="cover" wx:if='{{DetailsInfo.orderServiceInfo.thumb[0].img}}' class="ddimg" src="{{pageInfo.orderServiceInfo.thumb[0].img}}" ></image> -->
              <img v-if='DetailsInfo.orderServiceInfo.thumb[0].img' mode="cover" :src="DetailsInfo.orderServiceInfo.thumb[0].img" class='ddimg'>
              <div class='imgrigt'>
                <div class='imgtitle'>{{DetailsInfo.orderServiceInfo.productName}}</div>
                <div class='ddfee'>¥{{DetailsInfo.orderFee/100}}元</div>
              </div>
            </div>
          <div class="payInfo">
            <p class="orderStatus">联系人：{{DetailsInfo.receiveName}}</p>
            <p class="orderStatus">联系电话：{{DetailsInfo.receiveContact}}</p>
            <p class="orderStatus">收货地址：{{DetailsInfo.deliveryAddress}}</p>
            <p class="ddfee">备注</p>
            <p class="orderStatus">{{DetailsInfo.remark}}</p>
          </div>
        </div>
    </van-tab>
    <van-tab title="订单评论">
      <!-- <navigator title="详情" :routePath='"/bbs/blogList"'></navigator> -->

      <van-cell class='user_title'>
        <template slot="title">
          <div class="wrap">
            <img :src="detail.userIcon" class='avatar'>
            <span class="name">{{detail.userName}}</span>
            <span class="position">{{detail.position}}</span>
          </div>
        </template>
        <template slot="right-icon">
          <i class="iconfont icon-shanchu righticon van-cell__right-icon" @click='isDelete' v-show='detail.userId === localuser.userId'></i>
        </template>
      </van-cell>

      <div class="content">
        <p class="title">{{detail.subject}}</p>
        <p class="date">{{detail.createTime | DateFilter('yyyy-MM-dd hh:mm')}}</p>
        <div class="rich_text" ref='text' v-html='detail.content'></div> 
        
      </div>

      <div class="opration">
        <div class="likes">
          <i class="iconfont icon-dianzan" @click.stop='like' :class='{ "active": amILike }'></i>
          <span class="likenums" @click.stop='like'>{{detail.likes}}</span>
        </div>
        <div class="comments">
          <i class="iconfont icon-pinglun" @click.prevent='comment'></i>
          <span class="commentsnums" @click.prevent='comment'>{{detail.comments}}</span>
        </div>
      </div>

      <div class='all_or_mine'>
        <div>&nbsp;</div>
        <div :class='{ "active": active === options[0].key }' @click='changeActive(options[0].key)'>{{options[0].label}}({{detail.comments}})</div>
        <div>&nbsp;</div>
        <div :class='{ "active": active === options[1].key }'  @click='changeActive(options[1].key)'>{{options[1].label}}({{myTotal}})</div>
        <div>&nbsp;</div>
      </div>

      <van-list v-model="loading" :finished="finished" @load="loadMore">
        <div class="comment_list">
          <CommentItem v-for="(comment, index) in comments" :key="index" :isMine='detail.userId === localuser.userId' :comment='comment' :user='localuser' @deleteComment='deleteComment'></CommentItem>
        </div>
      </van-list>
      <div class='footer'>
        <mt-button @click.prevent='comment'>发布评论</mt-button>
      </div>
    </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CommentItem from './child/CommentItem';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { Tab, Tabs } from 'vant';
import { Divider } from 'vant';
import { NavBar } from 'vant';

export default {
  data() {
    return {
      // user: {},
      detail: {},
      id: '',
      actives: 1,
      DetailsInfo:{},
      amILike: false,
      duration: 1500,
      options: [
        { key: 0, label: '全部评论' },
        { key: 1, label: '我的评论' },
      ],
      active: 0,
      beginId: 0,
      comments: [],
      total: 0,
      loading: false,
      finished: false,
      myTotal: 0,
    };
  },

  methods: {
    // 获取用户信息
    // getUserInfo() {
    //   this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {}, {
    //     headers: { token: this.token },
    //   }).then((response) => {
    //     const res = response.data;
    //     if (res.resCode === '10000') {
    //       this.user = res.resData;
    //     }
    //   });
    // },
    // bbs详情
    getDetail() {
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/detail`, {
        id: this.id,
      }, {
        headers: { token: localStorage.getItem('swtoken') }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.detail = res.resData;
          this.amILike = this.detail.isLikes ? true : false;
        }
      });
    },
    // dd详情
    dddetail() {
      this.$http.post(`${this.URL_PREFIX}/app/get/water/order/detail`, {
        orderId: location.href.split('orderId=')[1],
      }, {
        headers: { token: localStorage.getItem('swtoken') }
      }).then((response) => {
        const res = response.data;
        console.log(res)
        if (res.resCode === '10000') {
            this.DetailsInfo = res.resData;
        }
      });
    },
    // 点赞
    like() {
      this.$http.post(`${this.URL_PREFIX}/app/opt/bbs/likes/log`, { 
        postId: this.detail.id,
      }, {
        headers: { token: localStorage.getItem('swtoken') },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.amILike = !this.amILike;
          if (this.amILike) {
            this.detail.likes += 1;
          } else {
            this.detail.likes -= 1;
          }
        }
      });
    },
    isDelete() {
      Dialog.confirm({
        title: '警告',
        message: '是否删除？'
      }).then(() => {
        this.deleteItem();
      }).catch(() => {
      });
    },
    // 删除
    deleteItem() {
      this.$http.post(`${this.URL_PREFIX}/app/delete/bbs/post`, {
        id: this.detail.id,
      }, {
        headers: { token: localStorage.getItem('swtoken') },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.$router.push('/bbs');
        } else {
          Toast.fail({ duration: this.duration, message:  res.resDesc});
        }
      });
    },
    // 删除评论
    deleteComment(id) {
      const index = this.comments.findIndex((item) => {
        return item.id === id;
      });
      this.comments.splice(index, 1);
      const len = this.comments.length;
      this.beginId = len ? this.comments[len - 1].id : 0;
      this.detail.comments -= 1;
      this.myTotal -= 1;
    },
    // 切换
    changeActive(key) {
      this.active = key;
      this.beginId = 0;
      this.comments = [];
      this.total = 0;
      if (key === 0) {
        this.getCommentList();
      } else {
        this.getMyComments();
      }
    },
    loadMore() {
      if (this.comments.length >= this.total) {
        return;
      }
      this.loading = true;
      if (this.active === this.options[0].key) {
        this.getCommentList();
      } else {
        this.getMyComments();
      }
    },
    // 获取评论列表
    getCommentList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/detail/allcomments`, {
        beginId: this.beginId,
        currPage: 1,
        pageRows: 10,
        postId: this.id,
        parkId: this.currentParkId,
      }, {
        headers: { token: localStorage.getItem('swtoken') },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.total = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          const tempArr = res.resData.pageList ? res.resData.pageList : [];
          this.comments = this.comments.concat(tempArr);
          this.finished = this.comments.length >= this.total ? true : false;
          const len = this.comments.length;
          this.beginId = len ? this.comments[len - 1].id : 0;
        }else{
          this.$toast(res.resDesc);
        }
        this.loading = false;
      });
    },
    // 获取我的评论列表
    getMyComments() {
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/detail/mycomments`, {
        beginId: this.beginId,
        currPage: 1,
        pageRows: 10,
        postId: this.id,
        parkId: this.currentParkId,
      }, {
        headers: { token: localStorage.getItem('swtoken') }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.total = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          const tempArr = res.resData.pageList ? res.resData.pageList : [];
          this.comments = this.comments.concat(tempArr);
          this.finished = this.comments.length >= this.total ? true : false;
          const len = this.comments.length;
          this.beginId = len ? this.comments[len - 1].id : 0;
        }else{
          this.$toast(res.resDesc);
        }
        this.loading = false;
      });
    },
    // 获取我得评论总数
    getMyCommentsLen() {
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/detail/mycomments`, {
        beginId: 0,
        currPage: 1,
        pageRows: 10,
        postId: this.id,
        parkId: this.currentParkId,
      }, {
        headers: { token: localStorage.getItem('swtoken') }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.myTotal = res.resData.pageList.length>0 ? res.resData.pageList.length : 0;
        }
      });
    },
    // 评论
    comment() {
      this.$router.push({ path: `/bbs/publishComment/${this.id}?orderId=${location.href.split('orderId=')[1]}` });
    },
  },
  computed: {
    ...mapGetters(['token', 'currentParkId', 'localuser']),
  },
  updated() {
    const ImgArr = this.$refs.text.querySelectorAll('.rich_text img') || [];
    ImgArr.forEach((item) => {
      item.style.maxWidth = '100%';
    });
  },
  components: {
    CommentItem,
  },
  created() {
    this.id = this.$route.params.id;
      // this.getUserInfo();
    this.getDetail();
    this.dddetail();
    this.getCommentList();
    if (!localStorage.getItem('swtoken')) {
      this.myTotal = 0;
      return;
    }
    this.getMyCommentsLen();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.detail{
  .user_title{
    padding: 0;
    height: 1.2rem;
    .wrap{
      padding: 0 .32rem;
      height: 1.2rem;
      line-height: 1.2rem;
      .avatar{
        margin-right: .213333rem;
        width: .8rem;
        height: .8rem;
        border-radius: 50%;
        vertical-align: middle;
      }
      .name, .position{
        color: rgb(102, 102, 102);
        font-size: .32rem;
      }
      .position{
        margin-left: .213333rem;
        font-size: .24rem;
      }
    }
    .van-cell__right-icon{
      padding: .16rem;
      font-size: .4rem;
      color: rgb(102, 102, 102);
    }
  }

  .content{
    padding: .32rem;
    background: #fff;
    .title{
      white-space: normal;
      word-break: break-all;
      @include lines-ellipsis;
      line-height: .64rem;
      font-size: .453333rem;
      color: rgb(51, 51, 51);
      font-weight: 600;
      text-align: center;
    }
    .date{
      line-height: .64rem;
      text-align: center;
      font-size: .32rem;
      color: rgb(102, 102, 102);
    }
  }

  .opration{
    margin-top: .026667rem;
    padding: 0 .32rem;
    display: flex;
    height: 1.2rem;
    line-height: 1.2rem;
    background: #fff;
    .likes, .comments{
      flex: 0 0 3.6rem;
      width: 3.6rem;
      .active{
        color: $color-main;
      }
    }
    i, span{
      padding: .16rem;
      box-sizing: border-box;
      font-size: .373333rem;
      color: rgb(102, 102, 102);
    }
  }
  .all_or_mine{
    margin-top: .133333rem;
    display: flex;
    height: 1.2rem;
    line-height: 1.2rem;
    background: #fff;
    div{
      flex: 1 1 auto;
      text-align: center;
      &.active{
        border-bottom: .053333rem solid $color-main;
      }
    }
  }

  .comment_list{
    padding: 0 .32rem;
    margin-top: .026667rem;
    background: #fff;
  }
  .footer{
     padding: px2rem(16) px2rem(24);
     background-color: #f5f5f5;
    margin-top: .4rem;
    box-sizing: border-box;
    width: 100%;
    .mint-button{
      width: 100%;
      height: 1.04rem;
      background: $color-main;
      color: #fff;
      font-size: .48rem;
    }
  }
}
.headerTitle{
  margin-top: .133333rem;
  font-size: .453333rem;
  font-weight: bold;
  background-color: #fff;
  padding: .36rem .32rem;
}
.orderBox{
    padding: .4rem .32rem;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-top: 1px solid rgb(245, 245, 245);
    .orderTitle{
      font-size: .453333rem;
      font-weight: bold;
    }
    .orderPrice{
      margin-top: .266667rem;
      font-size: .4rem;
      font-weight: bold;
      color: rgb(217, 38, 44);
    }
    .orderStatus{
      margin-top: .266667rem;
      font-size: .4rem;
      font-weight: bold;
    }
    .orderDetalis{
      margin-top: .4rem;
      border-top: 1px solid rgb(245, 245, 245);
      padding: .266667rem 0;
      box-sizing: border-box;

      .orderId{
        color: rgb(102, 102, 102);
      }
      .orderTime{
        color: rgb(102, 102, 102);
      }
    }
    .payInfo{
      border-top: 1px solid rgb(245, 245, 245);
      margin-top: .266667rem;
      padding: .266667rem 0;
      box-sizing: border-box;
      p{
        color: rgb(102, 102, 102);
      }
    }
    .processInfo{
      border-bottom: 1px solid rgb(245, 245, 245);
      margin-bottom: .266667rem;
      padding: .266667rem 0;
      box-sizing: border-box;
      .operateStatus{
        width: 13.3%;
        height: 3.6%;
        float: right;
      }
      p{
        color: rgb(102, 102, 102);
      }
    }
  }
  .imgbox{
    display:flex;
    align-items: flex-start;
    margin-bottom:30px;
  }
  .imgrigt{
    margin:0 0 30px 15px;
  }
  .imgtitle{
    margin-bottom:20px;
  }
  .ddfee{
    font-size:16px;
    margin-bottom:8px;
    color:red;
  }
  .ddimg{
    width: 2.666667rem;
    height: 2.666667rem;
    border-radius: .093333rem 0 0 .093333rem;
    display: inline-block;
    vertical-align: middle;
  }
</style>




// WEBPACK FOOTER //
// src/pages/bbs/components/BlogDetail.vue